/**
 * 错误码 → 交互与文案。只按 code 分支（ESLint 拦着按 message 分支）；sidecar 给的 detail 多是英文短语，
 * 不直接给人看，界面上的话在这里按 code 写，写「发生了什么 + 接下来怎么办」（DESIGN.md §4.17）。
 */
import { isApiError } from './client';
import type { ApiErrorCode } from './types';

export function codeOf(e: unknown): ApiErrorCode | 'client_exception' {
  return isApiError(e) ? e.code : 'client_exception';
}

/** 服务器或网络这一类：错误提示上给「重试」 */
export function isTransient(e: unknown): boolean {
  return ['network_offline', 'server_unreachable', 'timeout', 'server_error', 'unavailable', 'bad_response', 'access_log_unavailable'].includes(codeOf(e));
}

/**
 * 「{what}没有取到：…」。`what` 是这块数据的名字（「设备列表」）；`endpoint` 写进研发排查的那半句；
 * `unavailable` 给了就替换 503 的说法（测网设备读的是另一个库，原因不一样）。
 */
export function loadErrorText(e: unknown, what: string, opts: { endpoint?: string; unavailable?: string } = {}): string {
  const where = opts.endpoint ? `查 sidecar 日志里 ${opts.endpoint} 的报错` : '查 sidecar 日志';
  switch (codeOf(e)) {
    case 'unauthenticated':
      return `${what}没有取到：登录已经失效。刷新页面，会带你回入口重新登录。`;
    case 'forbidden':
      return `你的账号看不到${what}。需要的话找管理员。`;
    case 'reason_required':
      return `看这台设备的${what}前要先选查看理由。`;
    case 'access_log_unavailable':
      return `${what}暂时打不开：查看记录写不进去，按规定这时不能给出设备内容。稍后重试；一直这样就${where}。`;
    case 'not_found':
      return `${what}没有取到：接口说找不到。确认地址里的 SN 对不对。`;
    case 'unavailable':
      return opts.unavailable ?? `${what}暂时取不到：认证服务或数据库连不上。稍后重试；一直这样就${where}。`;
    case 'network_offline':
      return `${what}没有取到：网络断开了，恢复后会自动重试。`;
    case 'timeout':
      return `${what}没有及时返回。重试一次；还不行，${where}。`;
    default:
      return `${what}没有取到：数据接口报错或连不上。重试一次；还不行，${where}。`;
  }
}
